const OwnershipSection = () => (
  <section className="ownership-section">
    <div className="container">
      <span className="section-label text-primary">03 — THE MANDATE</span>
      <h2 className="section-main-title" style={{ fontSize: "3.5rem" }}>
        OWNERSHIP<br />WITHOUT PRESSURE.
      </h2>

      <div className="monolith-mandate">
        {[
          { num: "01", principle: "You will own what we build.", detail: "Full access. Complete control. No restrictions." },
          { num: "02", principle: "Ownership does not equal obligation.", detail: "You only manage what makes sense for you." },
          { num: "03", principle: "No technical demand.", detail: "The system works whether you touch it daily or never log in." },
          { num: "04", principle: "You define your control level.", detail: "From hands-off to hands-on. Your choice. Always." },
        ].map((item) => (
          <div key={item.num} className="monolith-item">
            <span className="monolith-index">{item.num}</span>
            <div className="monolith-content">
              <p className="monolith-principle">{item.principle}</p>
              <p className="monolith-detail">{item.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default OwnershipSection;
